import { render, staticRenderFns } from "./PickupInfoWrap.vue?vue&type=template&id=efc60c82&scoped=true"
import script from "./PickupInfoWrap.vue?vue&type=script&lang=js"
export * from "./PickupInfoWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc60c82",
  null
  
)

export default component.exports